//#region src/constants/time.ts
var e = 60, t = 3600, n = 86400, r = 86400 * 31, i = 86400 * 365;
//#endregion
export { n as SECONDS_PER_DAY, t as SECONDS_PER_HOUR, e as SECONDS_PER_MINUTE, r as SECONDS_PER_MONTH, i as SECONDS_PER_YEAR };
